<template>
  <section id="anfrage" class="bg-gradient-to-b to-white from-slate-100 py-4 sm:py-4 lg:py-4">
    <div class="mx-auto max-w-7xl p-4 sm:p-6 lg:p-8">
      <div class="bg-white rounded-lg shadow-md overflow-hidden">
        <div class="p-6 border-b border-gray-200">
          <h2 class="text-2xl md:text-3xl text-pink-700 font-ubuntu">Wir freuen uns auf Deine Anfrage</h2>
          <p class="mt-2 text-gray-600">Lass uns gemeinsam Deine Veranstaltung unvergesslich machen</p>
        </div>
        
        <div class="p-6">
          <form @submit.prevent="submitForm" class="space-y-6" autocomplete="off" data-lpignore="true" data-1p-ignore="true">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label for="name" class="block text-sm font-medium text-gray-700 mb-1">Name *</label>
                <input 
                  type="text" 
                  id="name" 
                  v-model="form.name" 
                  required 
                  autocomplete="name"
                  data-lpignore="true"
                  data-1p-ignore="true"
                  class="w-full p-3 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition duration-150" 
                  placeholder="Dein vollständiger Name"
                >
              </div>
              <div>
                <label for="anlass" class="block text-sm font-medium text-gray-700 mb-1">Anlass *</label>
                <div class="relative">
                  <select 
                    id="anlass" 
                    v-model="form.anlass" 
                    required
                    data-lpignore="true"
                    data-1p-ignore="true"
                    class="w-full p-3 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 appearance-none transition duration-150"
                  >
                    <option value="Hochzeit">Hochzeit</option>
                    <option value="Geburtstag">Geburtstag</option>
                    <option value="Firmenfeier">Firmenfeier</option>
                    <option value="JGA">JGA</option>
                    <option value="ABI-Feier">ABI-Feier</option>
                    <option value="Abschlussfeier">Abschlussfeier</option>
                    <option value="Einschulung">Einschulung</option>
                    <option value="Jugendweihe">Jugendweihe</option>
                    <option value="Messe">Messe</option>
                    <option value="Sommerfest">Sommerfest</option>
                    <option value="Weihnachtsfeier">Weihnachtsfeier</option>
                    <option value="anderer">Anderer Anlass</option>
                  </select>
                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label for="email" class="block text-sm font-medium text-gray-700 mb-1">E-Mail *</label>
                <input 
                  type="email" 
                  id="email" 
                  v-model="form.email" 
                  required 
                  autocomplete="email"
                  data-lpignore="true"
                  data-1p-ignore="true"
                  class="w-full p-3 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition duration-150" 
                  placeholder="deine@email.de"
                >
              </div>
              <div>
                <label for="telefon" class="block text-sm font-medium text-gray-700 mb-1">Telefon</label>
                <input 
                  type="tel" 
                  id="telefon" 
                  v-model="form.telefon" 
                  autocomplete="tel"
                  data-lpignore="true"
                  data-1p-ignore="true"
                  class="w-full p-3 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition duration-150" 
                  placeholder="Für Rückfragen"
                >
              </div>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label for="datum" class="block text-sm font-medium text-gray-700 mb-1">Datum der Veranstaltung *</label>
                <input 
                  type="date" 
                  id="datum" 
                  v-model="form.datum" 
                  required 
                  autocomplete="off"
                  data-lpignore="true"
                  data-1p-ignore="true"
                  class="w-full p-3 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition duration-150"
                >
              </div>
              <div>
                <label for="place" class="block text-sm font-medium text-gray-700 mb-1">Ort oder PLZ der Location *</label>
                <input 
                  type="text" 
                  id="place" 
                  v-model="form.event_location" 
                  required 
                  autocomplete="off"
                  data-lpignore="true"
                  data-1p-ignore="true"
                  class="w-full p-3 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition duration-150" 
                  placeholder="Adresse der Veranstaltung"
                >
              </div>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label for="aufstellung" class="block text-sm font-medium text-gray-700 mb-1">Aufstellung</label>
                <div class="relative">
                  <select 
                    id="aufstellung" 
                    v-model="form.aufstellung" 
                    data-lpignore="true"
                    data-1p-ignore="true"
                    class="w-full p-3 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 appearance-none transition duration-150"
                  >
                    <option value="Innenbereich">Innenbereich</option>
                    <option value="Außenbereich">Außenbereich</option>
                    <option value="weiß ich noch nicht">Weiß ich noch nicht</option>
                  </select>
                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </div>
              </div>
              <div>
                <label for="gaeste" class="block text-sm font-medium text-gray-700 mb-1">Anzahl der Gäste *</label>
                <div class="relative">
                  <select 
                    id="gaeste" 
                    v-model="form.gaeste" 
                    required 
                    data-lpignore="true"
                    data-1p-ignore="true"
                    class="w-full p-3 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 appearance-none transition duration-150"
                  >
                    <option value="bis 50">Bis 50 Gäste</option>
                    <option value="50-100">50 bis 100 Gäste</option>
                    <option value="100-200">100 bis 200 Gäste</option>
                    <option value="ueber-200">Mehr als 200 Gäste</option>
                    <option value="grossveranstaltung">Großveranstaltung</option>
                    <option value="messe">Messe / Event</option>
                    <option value="weiß ich noch nicht">Weiß ich noch nicht</option>
                  </select>
                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <label for="message" class="block text-sm font-medium text-gray-700 mb-1">Nachricht oder Fragen</label>
              <textarea 
                id="message" 
                v-model="form.message" 
                rows="4" 
                autocomplete="off"
                data-lpignore="true"
                data-1p-ignore="true"
                class="w-full p-3 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition duration-150" 
                placeholder="Weitere Details oder Fragen zu deiner Veranstaltung..."
              ></textarea>
            </div>
            
            <div>
              <div v-if="isGermanMobile" class="flex items-start mb-6">
                <div class="flex items-center h-5">
                  <input
                    id="whatsapp"
                    type="checkbox"
                    v-model="form.whatsapp"
                    autocomplete="off"
                    data-lpignore="true"
                    data-1p-ignore="true"
                    class="h-4 w-4 border-gray-300 rounded text-pink-600 focus:ring-pink-500"
                  >
                </div>
                <div class="ml-3 text-sm">
                  <label for="whatsapp" class="font-medium text-gray-700">Angebot auch per WhatsApp schicken</label>
                </div>
              </div>

              <button 
                type="submit" 
                class="w-full py-3 px-4 border border-transparent rounded-md shadow-md text-base font-medium text-white bg-pink-600 hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500 transition duration-150"
              >
                Anfrage senden
              </button>
            </div>
            
            <p class="text-xs text-gray-500 mt-2">* Pflichtfelder</p>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { importLibrary, setOptions } from "@googlemaps/js-api-loader"
import { onMounted, computed } from "vue";
import { ref } from 'vue';

const config = useRuntimeConfig();
const googleMapsApiKey = config.public.googleMapsApiKey?.trim();
const INQUIRY_API_URL = config.public.INQUIRY_API_URL;
const INQUIRY_API_TOKEN = config.public.INQUIRY_API_TOKEN;
const selectedPackage = useSelectedPackage();

const form = ref({
  name: '',
  telefon: '',
  email: '',
  message: '',
  aufstellung: 'Innenbereich',
  anlass: '',
  event_location: '',
  datum: getTodayDate(),
  gaeste: '',
  loc_long: '',
  loc_lat: '',
  privacy: true,
  whatsapp: false
});

const isGermanMobile = computed(() => {
  if (!form.value.telefon) return false;

  const cleaned = form.value.telefon.replace(/[\s\-\(\)]/g, '');
  const mobilePattern = /^(\+49|0049|0)(15\d|16\d|17\d)\d{7,8}$/;

  return mobilePattern.test(cleaned);
});

async function submitForm() {
  if (!form.value.name || !form.value.email || !form.value.datum || !form.value.event_location || !form.value.gaeste ) {
    alert('Bitte füllen Sie alle Pflichtfelder aus.');
    return;
  }

  try {
    const formData = {
      name: form.value.name,
      phone: form.value.telefon,
      email: form.value.email,
      occasion: form.value.anlass,
      event_location: form.value.event_location,
      event_date: form.value.datum,
      event_guests: form.value.gaeste,
      message: form.value.message,
      placement: form.value.aufstellung,
      gdpr_consent: form.value.privacy,
      locationLat: form.value.loc_lat,
      locationLong: form.value.loc_long,
      whatsapp_offer: form.value.whatsapp,
      package: selectedPackage.value,
      pageRef: window.location.href
    };
    
    await $fetch(INQUIRY_API_URL, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'x-api-token': INQUIRY_API_TOKEN
        },
      body: formData,
    });

    clearForm();
    window.location.assign('/anfrage-erhalten');
  } catch (error) {
    console.error('Fehler beim Absenden der Anfrage:', error);
    alert('Die Anfrage konnte leider nicht gesendet werden. Bitte versuchen Sie es erneut.');
  }
}

function clearForm() {
  form.value = {
    name: '',
    telefon: '',
    email: '',
    message: '',
    aufstellung: 'Innenbereich',
    anlass: '',
    event_location: '',
    datum: getTodayDate(),
    gaeste: '',
    loc_long: '',
    loc_lat: '',
    privacy: false,
    whatsapp: false
  };
}

function getTodayDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = (`0${today.getMonth() + 1}`).slice(-2);
  const day = (`0${today.getDate()}`).slice(-2);
  return `${year}-${month}-${day}`;
}

onMounted(async () => {
  if (!googleMapsApiKey) {
    return;
  }

  try {
    setOptions({
      key: googleMapsApiKey,
    });

    const { Autocomplete } = await importLibrary('places');

    const center = { lat: 52.520008, lng: 13.404954 }; 
    const defaultBounds = {
      north: center.lat + 0.5,
      south: center.lat - 0.5,
      east: center.lng + 0.5,
      west: center.lng - 0.5,
    };

    const input = document.getElementById("place") as HTMLInputElement | null;
    
    if (!input) {
      console.error("Eingabefeld für den Ort nicht gefunden");
      return;
    }
    
    const options = {
      bounds: defaultBounds,
      types: ["establishment", "geocode"],
      componentRestrictions: { country: "de" },
      fields: ["address_components", "geometry", "name", "formatted_address"],
      strictBounds: false,
    };

    const autocomplete = new Autocomplete(input, options);

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      
      if (place && place.formatted_address) {
        form.value.event_location = place.formatted_address;
        
        if (place.geometry && place.geometry.location) {
          form.value.loc_lat = place.geometry.location.lat();
          form.value.loc_long = place.geometry.location.lng();
        }
      }
    });
  } catch (error) {
    console.error("Fehler beim Laden der Places API:", error);
  }
});
</script>
